import { ModuleFE_ContextRule } from './ModuleFE_ContextRule.js';
export const ModulePackFE_ContextRuleDB = [ModuleFE_ContextRule];
//# sourceMappingURL=module-pack.js.map